export default __webpack_public_path__ + "static/media/luck.ada603c8.webp";